import Gateway from './gateway';
import { GatewayResponse } from '~types/gateway';

import { TLoginAPIParams, TLoginAPIResponse, TLogoutAPIParams, TLogoutReduxResponse } from '~types/feat/auth';

export abstract class IAuthGateway extends Gateway {
    abstract login(params: TLoginAPIParams): GatewayResponse<TLoginAPIResponse | null>;

    abstract logout(params: TLogoutAPIParams): GatewayResponse<TLogoutReduxResponse>;
}
